import { useAuthStore } from '../stores/authStore';
import { Platform } from '../services/platformDetector';

export const useAuth = () => {
  const store = useAuthStore();

  return {
    // Состояние
    isLoading: store.isLoading,
    isAuthenticated: store.isAuthenticated,
    isInitialized: store.isInitialized,
    platform: store.platform,
    user: store.user,
    isMatched: store.isMatched,
    error: store.error,
    branchVersion: store.branchVersion,

    // Действия
    logout: store.logout,
    clearError: store.clearError,
    setUser: store.setUser,
    bumpBranchVersion: store.bumpBranchVersion,

    // Удобные геттеры
    isTelegram: store.platform === Platform.TELEGRAM,
    isMax: store.platform === Platform.MAX,
    userName: store.user?.name,
    // Для совместимости со старым кодом
    userData: store.user ? {
      firstName: store.user.name?.split(' ')[0] || '',
      lastName: store.user.name?.split(' ').slice(1).join(' ') || undefined,
    } : null,
  };
};
